<div #toastContainer class="toast" role="status" (hidden.bs.toast)="onClose.emit(true)" [ngClass]="{
    'toast-default': eToastItemTypeList.Default == toastItem.type,
    'toast-primary': eToastItemTypeList.Primary == toastItem.type,
    'toast-secondary': eToastItemTypeList.Secondary == toastItem.type,
    'toast-success': eToastItemTypeList.Success == toastItem.type,
    'toast-danger': eToastItemTypeList.Danger == toastItem.type,
    'toast-warning': eToastItemTypeList.Warning == toastItem.type,
    'toast-info': eToastItemTypeList.Info == toastItem.type,
    'toast-light': eToastItemTypeList.Light == toastItem.type,
    'toast-dark': eToastItemTypeList.Dark == toastItem.type
  }">
  @if (toastItem.title != undefined) {
    <!-- && toastItem.title.length > 0 -->
    <div class="toast-header">
      <strong class="me-auto">{{ toastItem.title }}</strong>
      <button type="button" class="btn-close" (click)="onClose.emit(true)"></button>
    </div>
  }
  @if (toastItem.message && toastItem.message.length > 0) {
    <div class="toast-body" [innerHtml]="toastItem.message"></div>
  }
</div>
